import React, { useState } from 'react'
import { Button } from '@mui/material'
import { useStyles } from './SlidesStyles'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import LoadBalanceModal from './LoadBalanceModal'

export function LoadBalancer({ user }): JSX.Element {
  const classes = useStyles()
  const [loadBalanceModalOpen, setLoadBalancerModalOpen] = useState(false)
  const handleLoadBalancerModalOpen = (event) => {
    setLoadBalancerModalOpen(true)
  }
  const handleLoadBalancerModalClose = () => setLoadBalancerModalOpen(false)

  return (
    <>
      <Button
        className={`${classes.btn} ${classes.loadBalancerButton}`}
        variant="contained"
        onClick={(event) => handleLoadBalancerModalOpen(event)}
      >
        <PlayCircleOutlineIcon className={classes.sendIcon} />
        Run Load Balancer
      </Button>
      <LoadBalanceModal open={loadBalanceModalOpen} userId={user} onClose={handleLoadBalancerModalClose} />
    </>
  )
}

export default LoadBalancer
